import React, { useRef } from 'react';
import { useState, useEffect, usePrintContext, Hooks, Form, Field, Title, Code, Actions, API, Utility, Button, Messages, Control } from 'helpers/PrintImports';
import { Client } from 'models/ClientModel';
import SignaturePad from "components/common/SignManager";
import { useSearchParams } from 'react-router-dom';

const ConsentPrint13: React.FC = () => {
  const titleName = 'Audiology Consent';
  const [formId, formName] = [Code.Form.Id.CLIENT, Code.Form.Name.CLIENT];
  const {keyId, loading, setLoading, showMenu, setShowMenu, message, setMessage, error, setError, menuPosition, setMenuPosition, contextMenuRef } = usePrintContext();
  const [clientData, setClientData] = useState<Client>({});
  const [signData, setSignData] = useState<string>('');
  const [receiverName, setReceiverName] = useState<string>('');
  const [receiverPhone, setReceiverPhone] = useState<string>('');

  const [searchParams] = useSearchParams();
  const clientId = searchParams.get(Code.UrlPara.Client);
  const today = Utility.Date.Current();

  const Privilege = Hooks.Privilege.List(formId);
  const printRef = useRef<HTMLDivElement>(null);
  Hooks.Privilege.HasPrint(Privilege);
  const companyName = Utility.Storage.CompanyName();
  const companyId = Utility.Storage.CompanyId();
  const locationId = Utility.Storage.LocationId();

  useEffect(() => {
    if(!clientId) return;
    API.Data.GetByKeyId<Client>(formName, clientId, setLoading, setError)
      .then(async(data) => { if(data) {
      const formData = await Form.Map.Data(data);
      setClientData((prevData) => ({
        ...prevData,
        ...formData,
      }));
      setReceiverName(Utility.Get.FullName(data,Code.Form.Name.CLIENT))
      setReceiverPhone(data.client_phone || '')
    }})
    setLoading(false);
  }, []); 

  return (
    <Control.Print.Frame setMenuPosition={setMenuPosition} setShowMenu={setShowMenu}>
      {!loading && (<>
        <Messages.Toast Messages={message} Error={error} />
        <Button.Print keyId={keyId} formName={'Form'} showModify={false} Privilege={Privilege} clientData={clientData} fileName={titleName} docType={Code.Option.DocumentType.AUDIOLOGY_CONSENT} printRef={printRef} setMessage={setMessage} setError={setError} />
        <Control.Print.Data ref={printRef}>
            <Control.Flex>
              <Control.Column size={[0,60,0,0]}>
                <Control.Box>
                  <Field.CompanyHead companyId={companyId} locationId={locationId} />
                </Control.Box>
                <Control.Box>
                  <Field.Value value={Utility.Get.FullName(clientData, Code.Form.Name.CLIENT).toUpperCase()} valueBold={true} />
                  <Field.Value value={Utility.Format.Phone(clientData?.client_phone)} />
                  <Field.Value value={`${clientData?.client_address} ${clientData?.client_postal}`} />
                  <Field.Value title={Title.DOB} value={Utility.Format.DateOnly(clientData?.client_dob)} />
                  <Field.Value title={Title.ClientId} value={`#${clientData.client_number}`} />
                </Control.Box>
              </Control.Column>
              <Control.Column size={[0,40,0,0]} align={Code.Align.RIGHT}>
                <Control.Box>
                  <Field.SubHead title={titleName} />
                </Control.Box>
              </Control.Column>
            </Control.Flex>
            <div className="content-consent pt8">
              <p>I consent to the collection, by {companyName}, of necessary personal information such as date of birth, address, medical information, insurance information (if applicable), physical condition, function and social situation as it pertains to the assessment and management of my auditory function.</p>
              <p>I understand that information may be disclosed to the following parties: physicians, other health care providers, Alberta Aids For Daily Living (AADL), any third party insurance (including but not limited to WCB, NHIB, and IFHP), insurance companies, hearing aid manufacturers or legal agencies as necessary regarding your hearing health, and will maintain the security and privacy of this information in accordance with its privacy policy.</p>
              <p>I understand that {companyName} may collect, use and disclose information in order to process credit card payments, collect unpaid accounts or to invoice for unpaid goods and services.</p>
              <p>I understand that I have consented for {companyName} to provide the necessary assessments and treatment in regard to my hearing health care. Treatment may include (but is not limited to): hearing assessments, tinnitus assessments and treatments, ear wax removal, earmold impressions, minor hearing aid repair and cleaning, visual examination of my ears and hearing aids, etc.</p>
              <p>{companyName} does not sell or give out any patient files or personal information. Informatic must be kept for a minimum ten (10) years after the date of last entry in the file.</p>
              <p><strong>Date:</strong> {Utility.Format.Date(today,"MMMMM dd, yyyy")}</p>
            </div>
            <SignaturePad signData={signData} setSignData={setSignData} receiverName={receiverName} setReceiverName={setReceiverName} receiverPhone={receiverPhone} setReceiverPhone={setReceiverPhone} />
            
            <Field.PrintedOn fixed={false} />
        </Control.Print.Data>    
      </>)}
      {showMenu && (<div ref={contextMenuRef}><Control.PrintContextMenu keyId={keyId} showMenu={showMenu} formName={formName}  setShowMenu={setShowMenu} Privilege={Privilege} pos={menuPosition} /></div>)}
      <Actions.Print />
    </Control.Print.Frame>
  );
};

export default ConsentPrint13;